import { ColumnsType } from "antd/es/table";
import { Space, Dropdown } from "antd";
import { BotoesAcoes } from "../../ViewGerenciarPostagens/styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";
import { getMenuItems } from "../constants/itemsActionColumns";
import ColumnSearch from "../../../components/ColumnSearch";

export const Columns = (
  onClick: (e: any) => void,
  setInteresseId: (e: any) => void,
  filteredInfo: {
    dataIni?: string[] | null;
    dataFim?: string[] | null;
    situacao?: string[] | null;
    status?: string[] | null;
  }
): ColumnsType<any> => {
  const items = getMenuItems();

  return [
    {
      title: "Data início",
      dataIndex: "dataIni",
      key: "dataIni",
      width: "10%",
      align: "center",
      filteredValue: filteredInfo.dataIni || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.dataIni.includes(value),
      ...ColumnSearch<any>({ dataIndex: "dataIni" }),
    },
    {
      title: "Data fim",
      dataIndex: "dataFim",
      key: "dataFim",
      width: "10%",
      align: "center",
      filteredValue: filteredInfo.dataFim || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.dataFim.includes(value),
      ...ColumnSearch<any>({ dataIndex: "dataFim" }),
    },
    {
      title: "Situação",
      dataIndex: "situacao",
      key: "situacao",
      width: "10%",
      align: "center",
      filteredValue: filteredInfo.situacao || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.situacao.includes(value),
      ...ColumnSearch<any>({ dataIndex: "situacao" }),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "10%",
      align: "center",
      filteredValue: filteredInfo.status || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.status.includes(value),
      ...ColumnSearch<any>({ dataIndex: "status" }),
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                setInteresseId(row.id); // Define corretamente o ID do interesse;
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
